import alert from "@/plugins/alert/index"
import Cookies from 'js-cookie'
export  const getUid=({commit,state,getters})=>{
  return new Promise((resolve, reject) => {
    if (state.uid) {
      Cookies.set('uid',state.uid);
      resolve(state.uid);
    }
    let uid = '';
    let intV=null;
    function handleVisibilityChange() {
      if ((typeof window.document.hidden !== "undefined"&&window.document.visibilityState == 'visible')||(typeof window.document.webkitHidden !== "undefined"&&window.document.webkitVisibilityState == 'visible')) {
        uid = window.jsBridge.getUserId();
        if(uid){
          listenClear();
          clearInterval(intV);
          resolve(uid);
        }else{
         let ti= setTimeout(function () {
            uid = window.jsBridge.getUserId();
            clearTimeout(ti);
            if(uid){
              listenClear();
              clearInterval(intV);
              resolve(uid);
            }else{
              listenClear();
              reject();
            }
          },500)
        }
      }
    }
    function listenClear() {
      if (typeof window.document.hidden !== "undefined") {
        window.document.removeEventListener("visibilitychange", handleVisibilityChange);
      } else if (typeof window.document.webkitHidden !== "undefined") {
        window.document.removeEventListener('webkitvisibilitychange', handleVisibilityChange);
      }
    }
    if (window.navigator.userAgent.indexOf('ttplus')>-1) {
      uid = window.jsBridge.getUserId();
      if (!uid) {
        let times = 0;
        intV = setInterval(function () {
          uid = window.jsBridge.getUserId();
          times++;
          if (uid) {
            Cookies.set('uid',uid);
            state.uid = uid;
            clearInterval(intV);
            listenClear();
            resolve(uid);
          } else {
            if (times == 4) {
              alert({msg: '请登录App'}).then(function () {
                if (typeof window.document.hidden !== "undefined") {
                  window.document.addEventListener("visibilitychange", handleVisibilityChange);
                } else if (typeof window.document.webkitHidden !== "undefined") {
                  window.document.addEventListener('webkitvisibilitychange', handleVisibilityChange);
                }
                clearInterval(intV);
                window.jsBridge.login();
              });
            }
          }
          if (times > 20) {
            clearInterval(intV);
            //reject();
          }
        }, 500);
      } else {
        Cookies.set('uid',uid);
        state.uid = uid;
        listenClear();
        resolve(uid);
      }
    } else {
      uid = Cookies.get('uid');
      state.uid = uid;
      resolve(uid);
    }
  });
};



// WEBPACK FOOTER //
// ./src/store/actions.js